import React from "react";
import PropTypes from "prop-types";
import { TextField } from "formik-material-ui";
import InputMask from "react-input-mask";

const OutlineTextField = ({ onChange, ...props }) => {
  const handleOnChange = (e) => {
    props.form.setFieldValue(props.field.name, e.target.value);

    if (props.type === "number") {
      props.form.setFieldValue(
        props.field.name,
        String(e.target.value).replace(/-/g, '')
      );
    }

    if (onChange) return onChange(e);
  };

  return (
    <InputMask
      mask={props.mask}
      value={props.value}
      onBlur={props.onBlur}
      onChange={handleOnChange}
      disabled={props.disabled}
      maskPlaceholder={props.maskplaceholder ?? '_'}
    >
      <TextField
        style={{
          width: "100%",
          backgroundColor: props.disabled && "#eee",
        }}
        {...props}
        variant="outlined"
      />
    </InputMask>
  );
};

OutlineTextField.propTypes = {
  value: PropTypes.string,
  maskplaceholder: PropTypes.string,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
};

export default OutlineTextField;
